















import {Vue , Component} from 'vue-property-decorator';
import API from '@/Api';
@Component
export default class ProbationPopUp extends Vue {
    public dialog: boolean = false;
    public items: any = [];
    public mounted() {
        this.load();
    }
    public load() {
        API.Instance
        .get('/api/probation-pop-up')
        .then((response) => {
            // this.dialog = response.data;
            this.items = response.data;
        });
    }
}
